import { GridBaseDataProvider } from '../../../../../../../../grid/GridBaseDataProvider';
import { GetRowsRequest, SetFiltersRequest } from '../../../../../../../../grid/types/common';
import { ConsoleRequest, DataProviderType } from '../../../../../../../../utils/request';
import { CveColumnIndexes, CveColumnKeys, CveGridItem, CveRecord } from '../types';
import { GridHelper } from '../../gridHelper';

export class CveGridDataProvider extends GridBaseDataProvider<CveColumnIndexes, CveColumnKeys> {
  public patchId: string;
  private cveGridItems: Array<CveGridItem> = [];
  private columnKeys = [CveColumnKeys.CVE_ID];

  constructor(public dependencies: any) {
    super();
  }

  async getRows(request: GetRowsRequest<CveColumnIndexes, CveColumnKeys>): Promise<{ rawEvents: Array<CveGridItem> }> {
    if (this.cveGridItems.length) {
      return GridHelper.applyFiltersOnGridItems(request, this.cveGridItems, this.columnKeys);
    }

    const backEndResponse = await this.readRecords(request);
    this.cveGridItems = backEndResponse.records.map(patch => this.transformPatchRecordToGridItem(patch));

    return { rawEvents: this.cveGridItems };
  }

  private transformPatchRecordToGridItem(record: CveRecord): CveGridItem {
    return {
      [CveColumnKeys.CVE_ID]: record.cveId,
    };
  }

  private async readRecords(request: GetRowsRequest<CveColumnIndexes, CveColumnKeys>): Promise<any> {
    let response;

    const payload = ConsoleRequest.mapGridRequestToPayload(request, this.dependencies.getTimezone());
    payload.patchId = this.patchId;

    response = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      payload,
      endpoint: 'PatchesCatalog',
      method: 'getCveForPatch',
    });

    return response;
  }

  async setFilters(request: SetFiltersRequest<CveColumnKeys>): Promise<{} | undefined> {
    return {};
  }
}
